import _ from 'lodash';
import { dataFix } from '../../../../../global/common/dataFix';
import { ammend_sportsSeasonDataz, ammendSportsSeasonDatas } from './seasonSportsData';
import { _deleteMatchProps, _deleteMatchResultProps } from './seasonalDataHelpers';

export const _requiredMatchProps = ['away', 'home', 'levels', 'sections', 'startDate', 'startTime']

const _seasonalCollections = {
  districts: 'districts',
  organizations: 'organizations',
  schools: 'schools',
  sports: 'sports',
  teams: 'teams',
  tournaments: 'tournaments',
}

const ammend_updateProps = (updateProps, pks, callback) => {
  updateProps.pks = pks
  updateProps.callback = callback
}

const ammend_updateNameProps = (updateProps, collectionName, documentFieldName, data, opts) => {
  if (collectionName) { updateProps.collectionName = collectionName }
  if (documentFieldName) { updateProps.documentFieldName = documentFieldName }
  if (data) {
    updateProps.data = data
    updateProps.dataToUpdate = data
  }
  if (opts) { updateProps.opts = opts }
  updateProps.forSeasonal = !updateProps.collectionName ? true : false
}

const getPks = (pathViews, year_current, sportsKey, ignores) => {
  const _pks = {}
  Object.keys(pathViews).forEach(pv => {
    let allow = true
    if (ignores && ignores.includes(pv)) {
      allow = false
    }
    if (allow) {
      switch (pv) {
        case _seasonalCollections.districts:
        case _seasonalCollections.organizations:
        case _seasonalCollections.schools:
        case _seasonalCollections.sports:
        case _seasonalCollections.teams:
        case _seasonalCollections.tournaments:
          if (pathViews[pv]) {
            _pks[pv] = pathViews[pv]
          }
          break;
        default:
        // nothing
      }
    }
  })

  if (sportsKey) { _pks['sports'] = sportsKey }
  if (year_current) { _pks['sportsYears'] = parseInt(year_current) }
  return _pks
}

const isValidPks = (pks) => (pks.districts && pks.organizations && pks.sports && pks.sportsYears) ? true : false

const cleanMatchesForUpdate = (matches) => {

  if (!matches) return;

  _.forEach(matches, (match) => {
    // Remove top-level match props
    _.forEach(_deleteMatchProps, (prop) => {
      _.unset(match, prop);
    });

    const _match = dataFix.removeFalsyValues(match)

    const results = _.get(_match, 'results');

    if (_.isObject(results)) {
      // Remove shallow result props
      _.forEach(_deleteMatchResultProps, (prop) => {
        _.unset(results, prop);
      });

      const score = _.get(results, 'score');
      const home = _.get(score, 'home');
      const away = _.get(score, 'away');

      const validHome = _.isFinite(home);
      const validAway = _.isFinite(away);

      if (!(validHome && validAway)) {
        _.unset(match, 'results');
      }
    }
  });
};

const formatMatchesForUpdate = (matches, noLocation) => {
  const matchLevelGroups = _.groupBy(matches, '_matchCollectionKey')
  const groupedMatches = {}
  _.forEach(matchLevelGroups, (matches, levelKey) => {
    if (!groupedMatches[levelKey]) {
      groupedMatches[levelKey] = {}
    }
    _.forEach(matches, (match) => {
      const { isPlayoff, _itemKey } = match
      if (isPlayoff) {
        groupedMatches[levelKey]['playoffMatches.' + _itemKey] = match
      } else {
        groupedMatches[levelKey]['matches.' + _itemKey] = match
      }
    })
  })
  return groupedMatches
}

const ammend_matchLevelsAndSections = (matches) => {

  _.forEach(matches, (match) => {

    const homeLevels = match.home?.levels;
    const awayLevels = match.away?.levels;
    const homeSections = match.home?.sections;
    const awaySections = match.away?.sections;

    if (match._matchCollectionKey === 'Non') {

      if (_.isEqual(homeLevels, awayLevels)) {
        match.levels = homeLevels;
      } else {
        match.levels = 'Non';
      }

      if (!_.isEqual(homeSections, awaySections)) {
        match.sections = 'Non';
      }

    } else {

      if (!match.levels && _.isEqual(homeLevels, awayLevels)) {
        match.levels = homeLevels;
      }

      if (
        !match.sections &&
        _.isEqual(homeLevels, awayLevels) &&
        _.isEqual(homeSections, awaySections)
      ) {
        match.sections = homeSections;
      }

    }

    if (!match.bestOf) {
      match.bestOf = true;
    }

  });

};

export const seasonalHelpers = {
  ammend_sportsSeasonDataz,
  ammendSportsSeasonDatas,
  ammend_updateNameProps,
  ammend_updateProps,
  cleanMatchesForUpdate,
  formatMatchesForUpdate,
  getPks,
  isValidPks,
  ammend_matchLevelsAndSections
}
